import Index from '@tunnel-components/@sharded/error/container'

/**
 * @export Container
 */

export default Index



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/error/index.ts